import { render, staticRenderFns } from "./PaymentLink.vue?vue&type=template&id=26a309e2&scoped=true&"
import script from "./PaymentLink.vue?vue&type=script&lang=js&"
export * from "./PaymentLink.vue?vue&type=script&lang=js&"
import style0 from "./PaymentLink.vue?vue&type=style&index=0&id=26a309e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a309e2",
  null
  
)

/* custom blocks */
import block0 from "./PaymentLink.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/data/vstsagent/user/4158/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26a309e2')) {
      api.createRecord('26a309e2', component.options)
    } else {
      api.reload('26a309e2', component.options)
    }
    module.hot.accept("./PaymentLink.vue?vue&type=template&id=26a309e2&scoped=true&", function () {
      api.rerender('26a309e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/steps/PaymentData/PaymentLink.vue"
export default component.exports